import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Observable, of as observableOf, merge, BehaviorSubject, of } from 'rxjs';
import { RetrieveService } from '../api/services/retrieve.service';
import { AudiomatchChannel } from '../api/models/audiomatch-channel';
import { SearchParams } from './audiomatchchannels-list.component';

/**
 * Data source for the  AudiomatchrunsList view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class AudiomatchChannelsListDataSource implements DataSource<AudiomatchChannel> {

  private audiomatchChannelsSubject = new BehaviorSubject<AudiomatchChannel[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private audiomatchChannelsCount = new BehaviorSubject(0);

  public loading$ = this.loadingSubject.asObservable();
  public count$ = this.audiomatchChannelsCount.asObservable();

  constructor(private retrieveService: RetrieveService) {
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(collectionViewer: CollectionViewer): Observable<AudiomatchChannel[]> {
    return this.audiomatchChannelsSubject.asObservable();
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(collectionViewer: CollectionViewer): void {
    this.audiomatchChannelsSubject.complete();
    this.loadingSubject.complete();
  }

  loadAudiomatchChannels(params: SearchParams) {

    this.loadingSubject.next(true);

    /* Retrieve audiomatch runs */
    this.retrieveService.getAudiomatchChannels(params).pipe(
      catchError(() => {
        // console.error('getContentsList ERROR');
        return of([]);
      }),
      finalize(() => {
        // console.log('getContentsList OK');
        this.loadingSubject.next(false);
      })
    ).subscribe(contents => {
      // console.log(contents);
      this.audiomatchChannelsSubject.next(contents);
    });

    /* Count audiomatch runs */
    this.retrieveService.countAudiomatchChannels(params).pipe(
      catchError(() => {
        return of([]);
      }),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    ).subscribe(count => {
      this.audiomatchChannelsCount.next(count as number);
    });
  }
}

